import React, { useEffect, useReducer} from 'react';
import {Container, Row,Button, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"

const Advisory = () => {
    useEffect(() =>{
        document.title = "Advisory | Rich-Oak Group"
    },[])

    return (
      
      <div>





<div className="homepageslider" id="homepageslider">
<Header/>
{/* <Container className=''> */}


<div  id="advisoryfirstbox">
    <Row >
    <div className="col-md-7">
        <div className='hmfirstinnerbox'>
        <h3 className="hmfirstboxheading">Advisory Strategic<br/>Communication</h3>
        <p className='description hmfirstboxdescription'>

We focus on delivering alternative investment options to<br/> investors seeking long term financial growth and a<br/> diversified portfolio. We partner with individuals and<br/> institutions to achieve their financial goals
        
        </p>
        
        {/* <p class="centermobile">
        <button className='hmfirstboxbutton hmbuttons'>LEARN MORE</button>
        <h4 className="hmbuttons hmvot">View our team <img src="images/arrow_forward.png"/></h4>
        </p> */}

  
        </div>
    </div>
    </Row>
    </div>



    <div className='hmsecondbox'>
   
    </div>


  




    <div className='hmfourthbox'>


            <Row>
                <div className='col-md-5'>
                            <img class="img-fluid" src="images/whoweare2.png"/>

                    </div>
                    <div className='col-md-1'></div>

                    <div className='col-md-5'>
                  
                       {/* <img class="img-fluid" src="images/credit.png"/> */}
                       <p className='hmcia fordesktoponly'>Who
       <span style={{color:"#D80032"}} > We </span> Are
        
        </p>
     

        {/* <p className='hmcia formobileonly'>C
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p> */}
        <p  className="hmwwdp"></p>
        <p  className='hmfourthboxinner'>
        Entering into a new territory by new investors can be both challenging and exciting. Rich Oak’s professional support for businesses over the years has helped them to achieve hitch-free entry and scaling that enabled businesses break barriers without delay, in spite of the peculiar challenges of the Nigerian business environment.
        </p>
        <p  className='hmfourthboxinner'>
Rich Oak’s approach helps you cut through the complexity of market entry and business operations in Nigeria, by taking on your burden of Accounting, Tax, General operations and back-office activities so that you can focus on your core business                       
                            </p>
        {/* <img style={{width:"100%"}} src="images/whatwedo.png"/>  */}
                    </div>

        

                 
               
               
                
            </Row>

           
   
 
    </div> 
    <div class="hmfourthbox">
    <Row>
                <div className='col-md-5'>
        <p className='hmcia fordesktoponly'>What
       <span style={{color:"#D80032"}} > We </span> Do
        
        </p>
     

        {/* <p className='hmcia formobileonly'>C
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p> */}
        <p  className="hmwwdp"></p>
        <p  className='hmfourthboxinner'>
        Our people mean everything to us, we want to become Africa’s most reliable financial partner and we know how the right people can make this Vision possible. We are looking to invest In people who bring strong skills, commitment and excellence to their jobs, people who can take ownership of their roles and contribute positively to the company’s vision and to team growth.                        
                            </p>
        {/* <img style={{width:"100%"}} src="images/whatwedo.png"/>  */}
                    </div>
                    <div className='col-md-1'></div>

                    <div className='col-md-6'>
                  
                       {/* <img class="img-fluid" src="images/credit.png"/> */}
                       <div class="divinvestments">
                        <p className="hmciahead">Pre-start up advisory services</p>
                        <p  className='hmfourthboxinner'><img  style={{paddingRight:"15px"}} src="./images/check.png"/>  Market study </p>
                        <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/>  Entry strategy </p>
                        <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/>  Business regulation </p>

                            </div>

                            <div class="divinvestments2">
                            <p className="hmciahead">Business Operations Services</p>
                            <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/>  Business Plan/Feasibility Reports </p>
                        <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/>  Certifications and Licences (Scuml, Nsitf, Pencom) </p>
                        {/* <p  className='hmfourthboxinner'><img  src="./images/check.png"/>  Business regulation </p> */}
                            </div>

                            <div class="divinvestments2">
                            <p className="hmciahead">Account Services</p>
                            <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/>  Design and implementation of accounting policies and processes </p>
                        <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/>  Monthly bookeeping and management reporting</p>
                        <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/>  Employee Satisfaction </p>
                            </div>

                            <div class="divinvestments2">
                            <p className="hmciahead">Tax Services</p>
                            <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/> Tax advisory services</p>
                        <p  className='hmfourthboxinner'><img  style={{paddingRight:"15px"}}  src="./images/check.png"/>  Companies Income Tax processing</p>
                        <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/>  Withholding Tax processing</p>
                        <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/>  Value Added Tax processing</p>
                        <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/>  Personal Income tax processing</p>

                            </div>

                          
                    </div>

        

                 
               
               
                
            </Row>
    </div>



    <div className='hmseventhbox'>
    <div className=''>
    <h1 className="hmwwd2 fordesktoponly">Creating a great <span style={{color:"#D80032"}}>experience for you<br/></span> begins with  a conversation.</h1>
    <h1 className="hmwwd2 formobileonly">Creating a great <span style={{color:"#D80032"}}>experience for you </span> begins with a conversation.</h1>

            <hr class="hpwwdhr3"/>
       
            <Row className="innerboxseven">
        

                <div className='col-md-5'>
                    <h1 className='hmwwd2head'>Contact Info</h1>
                    <p className='innerboxsevendescription'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu leo cras in blandit mauris. Sociis dignissim luctus arcu lectus justo, vitae laoreet.
                    </p>

<div className='innersesventhbody'>
                    <Row>
                        <div class="col-md-1 col-2">
                            <img src="images/icons/phone.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <h1 className='innerboxsevendescriptionicon'>Phone number</h1>
                            <p className='innerboxsevendescriptiontext'>+234 123 456 7890, +234 123 456 7890</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                        <div class="col-md-1 col-2">
                            <img src="images/icons/mail.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Email address</p>
                            <p className='innerboxsevendescriptiontext'>samplemail@rich-oaks.com<br/> anothersamplemail2@rich-oaks.com</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                        <div class="col-md-1 col-2">
                            <img src="images/icons/office.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Address</p>
                            <p className='innerboxsevendescriptiontext'>Plot 1072 Grand Pela Hotel Street, Durumi Area 1. Abuja</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                        <div class="col-md-1 col-2">
                            <img src="images/icons/clock.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Office Hours</p>
                            <p className='innerboxsevendescriptiontext'>Mondays - Fridays: 9am - 5pm</p>
                        </div>
                    </Row>
                    </div>

                </div>
<hr className="hrmobile formobileonly"/>
                    <div className='col-md-1'></div>

                    <div className='col-md-5'>
                    <h1 className='hmwwd2head hmwwd2headmobile'>You can reach out to us</h1>

                    <p className='innerboxsevendescription'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu leo cras in blandit mauris. Sociis dignissim luctus arcu lectus justo, vitae laoreet.
                                          </p>

                                          <form className='hmformmobile'>
  <div class="form-group">
    <label className='hmlabel' for="">Full Name</label>
    <input type="email" class="form-control form-control-lg hminput" id=""placeholder="Enter email"/>
  </div>


  <div class="form-group">
    <label className='hmlabel hmlabel2' for="">Email Address</label>
    <input type="password" class="form-control form-control-lg hminput" id="" placeholder="Password"/>
  </div>

  <div class="form-group">
    <label className='hmlabel hmlabel2' for="">Message</label>
    <textarea class="form-control hminput" id="" rows="6"></textarea>
  </div>

  <button type="submit" class="hmfirstboxbutton">SEND YOUR MESSAGE</button>
</form>
                  
                    </div>

            
                  
                 
            </Row>
        </div>
    </div>


<br/>
<br/>


    </div>

<div id="homepagethirdbox">
    

</div>






    <Footer/>
    </div>


    )
    
    
}


export {Advisory as default}